const loadNews = ($template, data) => {
    const $clone = $template.content.cloneNode(true);

    /* UI */
    const $root = $clone.querySelector("[data-template='root']");
    const $image = $clone.querySelector("[data-template='image']");
    const $title = $clone.querySelector("[data-template='title']");
    const $tags = $clone.querySelector("[data-template='tags']");
    const $tagItem = $clone.querySelector("[data-template='tag']");
    const $date = $clone.querySelectorAll("[data-template='date']");
    const $linkWrapper = $clone.querySelector("[data-template='link']");
    const $foot = $clone.querySelector("[data-template='foot']");
    const $label = $clone.querySelector("[data-template='label']");

    /* Image */
    if (data.image.src) {
        const $imageEl = $image.querySelector('img');
        $imageEl.src = data.image.src;
        $imageEl.alt = data.image.alt;
        $imageEl.width = data.image.width;
        $imageEl.height = data.image.height;
    } else {
        $image.remove();
    }

    /* Title */
    $title.innerHTML = data.title;

    /* Tags */
    $tagItem.remove();
    
    data.categories.forEach((category) => {
        const $tag = $tagItem.cloneNode(true);
        $tag.innerHTML = category.label ?? category.name;
        $tags.appendChild($tag);
    });

    /* Year */
    $date.forEach(($dateEl) => {
        $dateEl.innerHTML = data.date;
        $dateEl.datetime = data.date;
    });

    /* Link */
    $linkWrapper.replaceChildren();
    
    if (data.cta && data.cta.url) {
        const $link = document.createElement('a');
        $link.className = 'c-tile-news_link';
        $link.href = data.cta.url;

        $label.innerHTML = data.cta.label ?? data.title;

        if (data.cta.isExternal) {
            $link.target = '_blank';
            $link.rel = 'noopener noreferrer';
        } else {
            $link.target = '_self';
        }
        
        const span = document.createElement('span');
        span.className = 'u-screen-reader-text';
        span.setAttribute('data-template', 'label');
        span.textContent = data.title;
        
        $link.appendChild(span);
        $linkWrapper.appendChild($link);     
        
        if (data.cta.isExternal) {
            $foot.innerHTML = $foot.innerHTML.replace(/arrow-right/g, 'arrow-external');
        } 

    } else {
        const $a11Title = document.createElement('span');
        $a11Title.className = 'u-screen-reader-text';
        $a11Title.textContent = data.title;
        $linkWrapper.appendChild($a11Title);
        $root.classList.remove('-link');
    }

    return $clone;
};

export default loadNews;
